import React from 'react';

export default function HeroSection({ socialLinks, onScrollToProjects }) {
  return (
    <section className="min-h-screen flex flex-col justify-center items-center text-center">
      <div className="mb-8 relative group">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-cyan-600 rounded-full blur-xl opacity-50 group-hover:opacity-75 transition-opacity duration-300 animate-pulse" />
        <div className="relative w-40 h-40 bg-gradient-to-br from-purple-500 via-pink-500 to-cyan-500 rounded-full mx-auto mb-6 flex items-center justify-center text-7xl font-bold shadow-2xl border-4 border-white/10 backdrop-blur-sm">
          V
        </div>
      </div>

      <div className="relative mb-4">
        <h1 className="text-5xl sm:text-7xl md:text-9xl font-black mb-2 bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 text-transparent bg-clip-text animate-pulse">
          Victor Gorshkov
        </h1>
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-cyan-600 blur-2xl opacity-20 -z-10" />
      </div>

      <div className="inline-block mb-4 px-6 py-3 bg-gradient-to-r from-purple-500/20 to-cyan-500/20 backdrop-blur-md rounded-full border border-purple-400/30">
        <p className="text-xl md:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-purple-300 to-cyan-300 font-bold">
          Software Developer in Test
        </p>
      </div>

      <p className="text-lg md:text-xl text-gray-400 max-w-2xl mb-12 leading-relaxed">Automation & Testing Portfolio</p>

      <div className="flex gap-6 mb-12" aria-label="Social links">
        {socialLinks.map((link) => {
          const Icon = link.icon;

          return (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="relative group"
              aria-label={link.label}
            >
              <div className={`absolute inset-0 bg-gradient-to-r ${link.gradientClass} rounded-full blur-lg opacity-0 group-hover:opacity-75 transition-opacity duration-300`} />
              <div className="relative p-4 bg-white/5 backdrop-blur-md rounded-full border border-white/10 transition-all duration-300 hover:scale-110 hover:bg-white/10 hover:border-white/30">
                <Icon size={28} />
              </div>
            </a>
          );
        })}
      </div>

      <button
        onClick={onScrollToProjects}
        className="group relative px-10 py-5 bg-gradient-to-r from-purple-600 to-cyan-600 rounded-full font-bold text-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/50"
      >
        <span className="relative z-10">Посмотреть проекты</span>
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </button>
    </section>
  );
}
